import { Injectable, signal } from '@angular/core';
import { ConfigService } from 'app/modules/shared/services/config.service';
import { RestApiService } from 'app/modules/shared/services/rest-api.service';
import { Observable } from 'rxjs';
import { MarkAllAsReadPayload, NotificationSearchParams } from '../models/notification';


@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private isNotificationTrayOpen = signal(false);
  constructor(
    private restApiService: RestApiService,
    private configService: ConfigService,
  ) { }

  toggleNotificationTray(): void {
    this.isNotificationTrayOpen.update(value => !value);
  }

  searchNotifications(params: NotificationSearchParams): Observable<unknown> {
    return this.restApiService.post(
      'SEARCH NOTIFICATIONS',
      `${this.configService.getLoggedInTenantCode()}/api/v1/notifications/search`,
      params,
      ''
    );
  }

  closeNotificationTray() {
    this.isNotificationTrayOpen.set(false);
  }

  get isNotificationTrayOpen$() {
    return this.isNotificationTrayOpen;
  }

  markAsRead(notificationId: string): Observable<unknown> {
    return this.restApiService.put(
      'MARK NOTIFICATION AS READ',
      `${this.configService.getLoggedInTenantCode()}/api/v1/notifications/${notificationId}/mark-as-read`,
      {},
      'page-center'
    );
  }

  markAllAsRead(action?: string): Observable<unknown> {
    const payload: MarkAllAsReadPayload = {
      lastClearedAt: 0,
      lastReadAt: Date.now(),
      eventCode: "e001",
      forTenantCode: this.configService.getLoggedInTenantCode()
    };

    if (action === 'CLEAR_ALL') {
      payload.lastClearedAt = Date.now();
    } else {
      payload.lastReadAt = Date.now();
    }

    return this.restApiService.put(
      'MARK ALL NOTIFICATIONS AS READ',
      `${this.configService.getLoggedInTenantCode()}/api/v1/notifications/update-status`,
      payload,
      'page-center'
    );
  }
} 